import React from 'react';
import { useNavigate } from 'react-router-dom';

const RoomTypesPage: React.FC = () => {
  const nav = useNavigate();
  React.useEffect(()=>{ nav('/dashboard/hotel-rooms', { replace:true }); }, [nav]);
  return null;
};

export default RoomTypesPage;


